console.log('Vite ⚡️ Rails')

// Sentry初期化（最初に実行）
import { initSentryFromMetaTags, setupStimulusErrorHandling } from '../lib/sentry'
initSentryFromMetaTags()

// Import Turbo
import * as Turbo from '@hotwired/turbo'
Turbo.start()

// Import and setup Stimulus
import { Application } from '@hotwired/stimulus'

// Import user controllers
import WithdrawalController from '../controllers/user/withdrawal_controller'
import RegistrationController from '../controllers/user/registration_controller'
import EmailVerificationController from '../controllers/user/email-verification_controller'
import JobTypeFormController from '../controllers/user/job_type_form_controller'
import MypageController from '../controllers/user/mypage_controller'
import PasswordStrengthController from '../controllers/user/password_strength_controller'
import ProfileController from '../controllers/user/profile_controller'
import SettingsFormController from '../controllers/user/settings_form_controller'

// Import shared controllers
import AddressController from '../controllers/shared/address_controller'

const application = Application.start()

// Stimulusエラーハンドリング
setupStimulusErrorHandling(application)

// Register controllers
application.register('withdrawal', WithdrawalController)
application.register('registration', RegistrationController)
application.register('address', AddressController)
application.register('email-verification', EmailVerificationController)
application.register('job-type-form', JobTypeFormController)
application.register('mypage', MypageController)
application.register('password-strength', PasswordStrengthController)
application.register('profile', ProfileController)
application.register('settings-form', SettingsFormController)

console.log('Stimulus initialized')

